import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f3eea6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { for: "selectNameInput" }
const _hoisted_4 = { class: "input-container" }

import {onMounted, ref} from 'vue';
import PFInput from "@/components/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    title: {}
  },
  emits: ['completed'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const name = ref('');
onMounted(() => {
  const input = document.getElementById('selectNameInput');
  if (input) {
    input.focus();
  }
})

function completed() {
  if (name.value && name.value.trim()) {
    emit('completed', name.value);
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(PFInput, {
          modelValue: name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          onCompleted: completed,
          "max-length": 25
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})